export { default as createBass } from './createBass';
export { default as createLead } from './createLead';
export { default as createPad } from './createPad';
export { default as createHat } from './createHat';
export { default as createReverseNoise } from './createReverseNoise';
export { default as createKick } from './createKick';
export { default as createSnare } from './createSnare';



// WEBPACK FOOTER //
// ./src/instruments/index.js